export const isSuperAdmin = (user) => Boolean(user?.is_superadmin || user?.is_superuser);

export const isPartner = (user) => {
    if (!user || isSuperAdmin(user)) return false;
    if (user.is_partner || ['partner', 'Партнери'].includes(user.role)) return true;
    return Array.isArray(user.groups) && user.groups.some((group) =>
        (typeof group === 'string' ? group : group?.name) === 'Партнери'
    );
};

export const getRole = (user) => {
    if (isSuperAdmin(user)) return 'superadmin';
    if (isPartner(user)) return 'partner';
    return user ? 'user' : null;
};

export const can = (user, capability) => {
    if (isSuperAdmin(user)) return true;
    if (user?.capabilities && Object.prototype.hasOwnProperty.call(user.capabilities, capability)) {
        return Boolean(user.capabilities[capability]);
    }
    return capability === 'partner_area' && isPartner(user);
};

export const canAccessRoute = (user, route) => {
    if (route === 'superadmin') return isSuperAdmin(user);
    if (route === 'partner') return isPartner(user) || isSuperAdmin(user);
    return Boolean(user);
};